import React from "react";

const AccessDenied = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img
        src="accessdenied.svg"    
        alt="Access Denied"
        style={{ width: "280px", marginBottom: "20px" }}
      />

      <h1 style={{ fontSize: "38px", fontWeight: "bold", color: "#dc3545" }}>
        403 - Access Denied
      </h1>

      <p style={{ fontSize: "18px", color: "#555", maxWidth: "500px" }}>
        You don’t have permission to access this page.  
        Please contact the administrator if you believe this is a mistake.
      </p>

      <a
        href="/"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#007bff",
          color: "#fff",
          borderRadius: "6px",
          textDecoration: "none",
          fontSize: "16px",
        }}
      >
        Go to Home
      </a>
    </div>
  );
};

export default AccessDenied;
